import React from 'react';
import '../css/MyProfile.css'; // Add your CSS file for styling
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';
import profileImg from '../images/profile.png'

const MyProfile = () => {
    // Assuming user data is stored in localStorage
    const user = JSON.parse(localStorage.getItem('user')) || {
        name: 'Guest',
        email: 'guest@example.com',
        phone: 'Not Provided',
        profileImg: 'default-avatar.png',
    };

    return (
        <div className='profile'>
            <NavbarComponent/>
  
        <div className="profile-container">
            <div className="profile-card">
       
                <div className="profile-info">
                <h1 className="profile-header">My Profile</h1>
                <img
                    src={user.profileImg || profileImg}
                    alt="User Avatar"
                    className="profile-image"
                />
                    <p><strong>Name:</strong> {user.name}</p><br/>
                    <p><strong>Email:</strong> {user.email}</p><br/>
                    <p><strong>Phone:</strong> {user.phone}</p><br/>
                    <p><strong>Date of Birth:</strong> {user.dob}</p><br/>
                    <p><strong>Wallet Amount:</strong> {user.walletAmount}</p><br/>
                    <p><strong>Nationality:</strong> {user.nationality}</p><br/>
                    <p><strong>Gender:</strong> {user.gender}</p><br/>
                    <p><strong>Marital Status:</strong> {user.maritalStatus}</p><br/>
                </div>
            </div>
        </div>

            <FooterComponent/>
        </div>
    );
};

export default MyProfile;
